export { getStoresServerAction } from 'next-flight-server-reference-proxy-loader?id=70ef078e556057cd14bef8f7b098456d94c511f19c&name=getStoresServerAction!'